import request from 'services/request';
import {
  SpecialPackageChartUrl,
  SpecialPackageDataUrl,
} from 'routes/specialPackage.routes';
import { convertJalaliToGregorian } from 'utils/common.util';
import { normalizeChartData } from 'utils/specialPackages.util';

export const setHideDetailsCardAction = (
  set,
  showDetailsCard?: boolean,
): void => set(() => ({ isHideDetailsCard: showDetailsCard }));

export const getChartDataAction = async (
  set,
  startDate: string,
  endDate: string,
): Promise<void> => {
  set({ chartDataLoading: true, chartData: null, chartDataError: false });
  const response = await request.get(
    SpecialPackageChartUrl(
      convertJalaliToGregorian(startDate),
      convertJalaliToGregorian(endDate),
    ),
  );
  if (response.ok) {
    set({
      chartData: normalizeChartData(response.data.data.chart),
      chartDataLoading: false,
    });
    !startDate &&
      set((state) => ({
        defaultChartData: normalizeChartData(response.data.data.chart),
        startDate: state.chartData[0].date,
        endDate: state.chartData[state.chartData.length - 1].date,
      }));
  } else
    set({ chartDataLoading: false, chartData: null, chartDataError: true });
};

export const getListDataAction = async (set): Promise<void> => {
  set({ listDataLoading: true, listData: null, listDataError: false });
  const response = await request.get(SpecialPackageDataUrl());
  if (response.ok) {
    set({
      listData: response.data.data,
      listDataLoading: false,
    });
  } else {
    set({ listDataLoading: false, listDataError: true, listData: null });
  }
};

export const setIsSampleBasketAction = (set, isSampleBasket: boolean): void =>
  set({ isSampleBasket });
